<app-block-wrapper
  [_editable]="_editable"
  [style]="style"
  [class.dark]="style[0]?.background === 'dark' || style[0]?.background === 'black'"
  [class.black]="style[0]?.background === 'black'"
>
  <div class="company-logo-list">
    <div [innerHTML]="contentAboveHtml" *ngIf="contentAboveHtml" class="above-logos-content standard-dark-text"></div>

    <div class="empty" *ngIf="companies && !companies.length">EMPTY COMPANY LOGO LIST</div>

    <div
      class="company-list"
      [class.with-ratings]="showRating"
      [style.--item-count]="companies.length"
      [class.animated]="companies.length > 6"
    >
      <div class="company-list-inner" [style.animation-duration]="companies.length * 5 + 's'">
        <div class="company-list-item" *ngFor="let company of companies">
          <img [src]="company.logo.filename | storyblokCdn" [alt]="company.logo.alt" />

          <div *ngIf="showRating" class="stars">
            <div *ngFor="let star of getStars(company.rating)" [class]="star"></div>
          </div>
        </div>

        <ng-container *ngIf="companies.length > 6">
          <div class="company-list-item extra" *ngFor="let company of companies">
            <img
              [src]="company.logo.filename | storyblokCdn"
              [alt]="company.logo.alt"
              [attr.width]="company.dimensions.width"
              [attr.height]="company.dimensions.height"
            />

            <div *ngIf="showRating" class="stars">
              <div *ngFor="let star of getStars(company.rating)" [class]="star"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-block-wrapper>
